"use client"

import React from "react"

const Footer = () => {
  const handleFooterNavClick = (e, sectionId) => {
    e.preventDefault()
    const el = document.getElementById(sectionId)
    if (el) {
      el.scrollIntoView({ behavior: "smooth" })
      window.history.replaceState(null, "", window.location.pathname)
    }
  }

  const navItems = [
    { label: "About", id: "home" },
    { label: "Skills", id: "skills" },
    { label: "Experience", id: "experience" },
    { label: "Education", id: "education" },
    { label: "Projects", id: "projects" },
    { label: "Activities", id: "activities" },
    { label: "Cherished One", id: "cherished" },
    { label: "Contact", id: "contact" },
  ]

  return (
    <div className="w-full py-8 flex justify-center bg-bg-primary">
      <footer className="w-full max-w-[1200px] flex flex-col gap-[14px] items-center px-4 text-text-dark">
        <h1 className="font-semibold text-[25px] text-primary-blue font-rem">SRIRAM GANDROTHU</h1>

        <nav className="w-full max-w-[800px] mt-[0.9rem] flex flex-row gap-8 justify-center flex-wrap">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={(e) => handleFooterNavClick(e, item.id)}
              className="text-white text-[13px] md:text-[15px] transition-colors duration-200 hover:text-primary-blue"
              type="button"
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="flex gap-6 mt-4">
          {/* Social Icons */}
          {[
            {
              href: "https://github.com/sriramgandrothu",
              icon: "fa-github",
            },
            {
              href: "https://www.linkedin.com/in/sriramgandrothu/",
              icon: "fa-linkedin",
            },
            {
              href: "https://instagram.com/sriramgandrothu?utm_source=qr&igshid=MzNlNGNkZWQ4Mg==",
              icon: "fa-instagram",
            },
            {
              href: "https://wa.me/7842713943",
              icon: "fa-whatsapp",
            },
            {
              href: "mailto:sriramgandrothu@gmail.com",
              icon: "fa-envelope",
              isRegular: true,
            },
          ].map((item, idx) => (
            <a
              key={idx}
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex justify-center items-center w-16 h-16 bg-transparent border-2 border-accent rounded-full text-[2rem] text-accent transition-all duration-300 hover:bg-accent hover:text-bg-secondary hover:shadow-[0_0_1rem_#59b2f4]"
            >
              <i className={`fa-${item.isRegular ? "regular" : "brands"} ${item.icon}`}></i>
            </a>
          ))}
        </div>

        <p className="mt-6 text-[14px] md:text-[16px] text-white text-center">
          &copy; 2025-{new Date().getFullYear()} Made with 💓. All rights reserved.
        </p>
      </footer>
    </div>
  )
}

export default Footer
